import { render, staticRenderFns } from "./pointPool.vue?vue&type=template&id=4c6c6809"
import script from "./pointPool.vue?vue&type=script&lang=js"
export * from "./pointPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports